<template>
  <button :type="type" class="flex justify-center items-center p-2 rounded-full" :class="customClass ? customClass : 'custom-button'" :disabled="disabled" @click="handleClick">

    <component v-if="icon" :is="icon" class="duration-500 hover:scale-115 active:scale-100" :class="customIcon ? customIcon : 'icon'" />
    <span v-if="title" :class="customClassTitle ? customClassTitle : 'button-title'">{{ title }}</span>

    <slot></slot>
  </button>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue';

const props = defineProps({
  icon: Object,
  title: String,
  disabled: Boolean,
  onClick: Function,
  customClass: String,
  customClassTitle: String,
  customIcon: String,
  type: {
    type: String,
    default: 'button',
  },
});

const emit = defineEmits(['click']);


const handleClick = (event) => {
  if (!props.disabled) {
    if (props.onClick) {
      props.onClick(event);
    } else {
      emit('click', event);
    }
  }
};
</script>

<style>
.custom-button {
  color: #fff;
  cursor: pointer;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  transition: background 0.3s ease;
}

.custom-button:disabled {
  background-color: #A0A0A0;
  cursor: not-allowed;
}

.custom-button:hover:not(:disabled) {
  background-color: var(--c-primary);
}


.button-title {
  font-weight: lighter;
  font-size: 18px;
  color: #fff;
}
</style>
